import { render, staticRenderFns } from "./topHeader.vue?vue&type=template&id=45c04d08&scoped=true"
import script from "./topHeader.vue?vue&type=script&lang=js"
export * from "./topHeader.vue?vue&type=script&lang=js"
import style0 from "./topHeader.vue?vue&type=style&index=0&id=45c04d08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c04d08",
  null
  
)

export default component.exports